var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 4.59961L10.8574 9.59961L2.85742 4.59961V2.59961L10.8574 7.59961L18.8574 2.59961M18.8574 0.599609H2.85742C1.74742 0.599609 0.857422 1.48961 0.857422 2.59961V14.5996C0.857422 15.13 1.06814 15.6388 1.44321 16.0138C1.81828 16.3889 2.32699 16.5996 2.85742 16.5996H18.8574C19.3879 16.5996 19.8966 16.3889 20.2716 16.0138C20.6467 15.6388 20.8574 15.13 20.8574 14.5996V2.59961C20.8574 1.48961 19.9574 0.599609 18.8574 0.599609Z",
    fill: "#EE1E12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/contact-mail.273e283d4bf5920e46e9b8c435f9cb91.svg";
export { ForwardRef as ReactComponent };